import isEmail from "validator/lib/isEmail";

export const email = (value) => isEmail(value ?? "") ? undefined : "Invalid email";
